/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BirthHistory from './birth-history';
import BirthHistoryDetail from './birth-history-detail';
import BirthHistoryUpdate from './birth-history-update';
import BirthHistoryDeleteDialog from './birth-history-delete-dialog';

const BirthHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BirthHistory />} />
    <Route path="new" element={<BirthHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<BirthHistoryDetail />} />
      <Route path="edit" element={<BirthHistoryUpdate />} />
      <Route path="delete" element={<BirthHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BirthHistoryRoutes;
